import {
  ADD_CUSTOMER_REQUEST,
  ADD_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_FAILURE,
  FETCH_CUSTOMERS_REQUEST,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAILURE,
  DELETE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAILURE,
  FETCH_CUSTOMER_DETAILS_REQUEST,
  FETCH_CUSTOMER_DETAILS_SUCCESS,
  FETCH_CUSTOMER_DETAILS_FAILURE,
  RESET_CUSTOMER_STATE,
  FETCH_ALL_CUSTOMERS_REQUEST,
  FETCH_ALL_CUSTOMERS_SUCCESS,
  FETCH_ALL_CUSTOMERS_FAILURE,
  RESEND_CUSTOMER_PASSWORD_SUCCESS,
  RESEND_CUSTOMER_PASSWORD_FAILURE,
  CLEAR_RESEND_PASSWORD_STATUS,
  RESEND_CUSTOMER_PASSWORD_REQUEST,
  CONVERT_VENDOR_TO_CUSTOMER_REQUEST,
  CONVERT_VENDOR_TO_CUSTOMER_SUCCESS,
  CONVERT_VENDOR_TO_CUSTOMER_FAILURE,
  CLEAR_CONVERT_VENDOR_TO_CUSTOMER_STATUS,
  CONVERT_ROLE_REQUEST,
  CONVERT_ROLE_SUCCESS,
  CONVERT_ROLE_FAILURE,
  CLEAR_CONVERT_ROLE_STATUS,
} from "../types/customerTypes";

export const convertRoleRequest = (data) => ({
  type: CONVERT_ROLE_REQUEST,
  payload: data,
});

export const convertRoleSuccess = (message) => ({
  type: CONVERT_ROLE_SUCCESS,
  payload: message,
});

export const convertRoleFailure = (error) => ({
  type: CONVERT_ROLE_FAILURE,
  payload: error,
});

export const clearConvertRoleStatus = () => ({
  type: CLEAR_CONVERT_ROLE_STATUS,
});

export const fetchAllCustomersRequest = (params) => ({
  type: FETCH_ALL_CUSTOMERS_REQUEST,
  payload: params,
});
export const fetchAllCustomersSuccess = (customers) => ({
  type: FETCH_ALL_CUSTOMERS_SUCCESS,
  payload: customers,
});
export const fetchAllCustomersFailure = (error) => ({
  type: FETCH_ALL_CUSTOMERS_FAILURE,
  payload: error,
});
export const addCustomerRequest = (customerData) => ({
  type: ADD_CUSTOMER_REQUEST,
  payload: customerData,
});
export const addCustomerSuccess = (message) => ({
  type: ADD_CUSTOMER_SUCCESS,
  payload: message,
});
export const addCustomerFailure = (error) => ({
  type: ADD_CUSTOMER_FAILURE,
  payload: error,
});
export const fetchCustomersRequest = (payload) => ({
  type: FETCH_CUSTOMERS_REQUEST,
  payload,
});
export const fetchCustomersSuccess = (customers) => ({
  type: FETCH_CUSTOMERS_SUCCESS,
  payload: customers,
});
export const fetchCustomersFailure = (error) => ({
  type: FETCH_CUSTOMERS_FAILURE,
  payload: error,
});
export const updateCustomerRequest = (data) => ({
  type: "UPDATE_CUSTOMER_REQUEST",
  payload: data,
});
export const updateCustomerSuccess = (updatedCustomer) => ({
  type: UPDATE_CUSTOMER_SUCCESS,
  payload: updatedCustomer,
});
export const updateCustomerFailure = (error) => ({
  type: UPDATE_CUSTOMER_FAILURE,
  payload: error,
});
export const deleteCustomerRequest = (customerId) => ({
  type: DELETE_CUSTOMER_REQUEST,
  payload: customerId,
});
export const deleteCustomerSuccess = (customerId) => ({
  type: DELETE_CUSTOMER_SUCCESS,
  payload: customerId,
});
export const deleteCustomerFailure = (error) => ({
  type: DELETE_CUSTOMER_FAILURE,
  payload: error,
});
export const fetchCustomerDetailsRequest = (customerId) => ({
  type: FETCH_CUSTOMER_DETAILS_REQUEST,
  payload: customerId,
});
export const fetchCustomerDetailsSuccess = (customerData) => ({
  type: FETCH_CUSTOMER_DETAILS_SUCCESS,
  payload: customerData,
});
export const fetchCustomerDetailsFailure = (error) => ({
  type: FETCH_CUSTOMER_DETAILS_FAILURE,
  payload: error,
});
export const resetCustomerState = () => ({
  type: RESET_CUSTOMER_STATE,
});
export const clearDeleteSuccess = () => ({
  type: "CLEAR_DELETE_SUCCESS",
});
export const resendCustomerPasswordRequest = (email) => ({
  type: RESEND_CUSTOMER_PASSWORD_REQUEST,
  payload: email,
});

export const resendCustomerPasswordSuccess = (response) => ({
  type: RESEND_CUSTOMER_PASSWORD_SUCCESS,
  payload: response,
});

export const resendCustomerPasswordFailure = (error) => ({
  type: RESEND_CUSTOMER_PASSWORD_FAILURE,
  payload: error,
});

export const clearResendPasswordStatus = () => ({
  type: CLEAR_RESEND_PASSWORD_STATUS,
});

export const convertVendorToCustomerRequest = (vendorId) => ({
  type: CONVERT_VENDOR_TO_CUSTOMER_REQUEST,
  payload: vendorId,
});

export const convertVendorToCustomerSuccess = (message) => ({
  type: CONVERT_VENDOR_TO_CUSTOMER_SUCCESS,
  payload: message,
});

export const convertVendorToCustomerFailure = (error) => ({
  type: CONVERT_VENDOR_TO_CUSTOMER_FAILURE,
  payload: error,
});

export const clearConvertVendorToCustomerStatus = () => ({
  type: CLEAR_CONVERT_VENDOR_TO_CUSTOMER_STATUS,
});
